import { Routes } from "@angular/router";
import { ViewContractsGuard } from "@app/app-modules/view-contract/view-contracts.guard";
import { ViewTermsAndConditionsGuard } from "@app/app-modules/view-terms-and-conditions/view-terms-and-conditions.guard";
import { TokenGuard } from "@app/core/guards/token.guard";
import { ADMIN_ROUTES } from "@app/portals/admin-modules/admin-shared/constants/routes.constants";
import { AdminGuard } from "@app/portals/admin-modules/admin-shared/guards/admin.guard";
import { GLH_ROUTES } from "@app/portals/glh-modules/glh-shared/constants/routes.constants";
import { GlhGuard } from "@app/portals/glh-modules/glh-shared/guards/glh.guard";
import { HOUSE_ROUTES } from "@app/portals/house-modules/house-shared/constants/routes.constants";
import { HouseGuard } from "@app/portals/house-modules/house-shared/guards/house.guard";
import { ILH_ROUTES } from "@app/portals/ilh-modules/ilh-shared/constants/routes.constants";
import { IlhGuard } from "@app/portals/ilh-modules/ilh-shared/guards/ilh.guard";
import { WC_ROUTES } from "@app/portals/wc-modules/wc-shared/constants/routes.constants";
import { WcGuard } from "@app/portals/wc-modules/wc-shared/guards/wc.guard";
import { ChangePasswordGuard } from "@app/shared/components/change-password/change-password.guard";
import { TwoFactorAuthenticationGuard } from "@app/shared/components/two-factor-authentication/two-factor-authentication.guard";
import { ROUTES } from "@app/shared/constants/routes.constants";

export const routes: Routes = [
  //////
  // Shared Routes across all portals not wrapped in a shell container.
  //////
  {
    path: ROUTES.ERROR,
    loadChildren: () => import("@app/app-modules/error/error-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.DISABLED,
    loadChildren: () => import("@app/app-modules/disabled/disabled-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.LOGIN,
    loadChildren: () => import("@app/app-modules/login/login-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    loadChildren: () => import("@app/app-modules/forgot-password/forgot-password-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.SELF_REGISTRATION,
    loadChildren: () => import("@app/app-modules/self-registration/self-registration-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.NOTIFICATION_ARTICLES,
    loadChildren: () => import("@app/app-modules/view-articles/view-articles-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.FIRST_TIME,
    loadChildren: () => import("@app/app-modules/first-time/first-time-routes").then((m) => m.routes)
  },
  {
    path: ROUTES.TERMS_AND_CONDITIONS,
    canActivate: [ViewTermsAndConditionsGuard],
    loadComponent: () =>
      import(
        "@app/app-modules/view-terms-and-conditions/view-terms-and-conditions/view-terms-and-conditions.component"
      ).then((m) => m.ViewTermsAndConditionsComponent)
  },
  {
    path: ROUTES.CONTRACTS,
    canActivate: [ViewContractsGuard],
    loadComponent: () =>
      import("@app/app-modules/view-contract/view-contract/view-contract.component").then(
        (m) => m.ViewContractsComponent
      )
  },
  {
    path: ROUTES.TWO_FACTOR_VERIFY,
    canActivate: [TwoFactorAuthenticationGuard],
    loadComponent: () =>
      import(
        "@app/shared/components/two-factor-authentication/two-factor-authentication-form-verify/two-factor-authentication-form-verify.component"
      ).then((m) => m.TwoFactorAuthenticationFormVerifyComponent)
  },
  {
    path: ROUTES.TWO_FACTOR_ENABLE,
    canActivate: [TwoFactorAuthenticationGuard],
    loadComponent: () =>
      import(
        "@app/shared/components/two-factor-authentication/two-factor-authentication-enable/two-factor-authentication-enable.component"
      ).then((m) => m.TwoFactorAuthenticationEnableComponent)
  },
  {
    path: ROUTES.CHANGE_PASSWORD,
    canActivate: [ChangePasswordGuard],
    loadComponent: () =>
      import("@app/shared/components/change-password/change-password-card/change-password-card.component").then(
        (m) => m.ChangePasswordCardComponent
      )
  },
  //////
  // Authenticated Routes inside shell container
  //////
  {
    path: ADMIN_ROUTES.BASE,
    loadChildren: () => import("@admin/admin-shell/admin-shell-routes").then((m) => m.routes),
    canMatch: [AdminGuard],
    canActivate: [TokenGuard]
  },
  {
    path: HOUSE_ROUTES.BASE,
    loadChildren: () => import("@house/house-shell/house-shell-routes").then((m) => m.routes),
    canMatch: [HouseGuard],
    canActivate: [TokenGuard]
  },
  {
    path: GLH_ROUTES.BASE,
    loadChildren: () => import("@glh/glh-shell/glh-shell-routes").then((m) => m.routes),
    canMatch: [GlhGuard],
    canActivate: [TokenGuard]
  },
  {
    path: ILH_ROUTES.BASE,
    loadChildren: () => import("@ilh/ilh-shell/ilh-shell-routes").then((m) => m.routes),
    canMatch: [IlhGuard],
    canActivate: [TokenGuard]
  },
  {
    path: WC_ROUTES.BASE,
    loadChildren: () => import("@wc/wc-shell/wc-shell-routes").then((m) => m.routes),
    canMatch: [WcGuard],
    canActivate: [TokenGuard]
  },
  {
    path: "**",
    loadComponent: () =>
      import("@app/app-modules/error/error-404/error-404.component").then((m) => m.Error404Component),
    pathMatch: "full"
  }
];
